import { AppNotification } from '../../../../types';

// Maps the documents gateway's refresh/version error statuses to actionable notifications.
// Returns null for statuses it doesn't know about — fall back to handleServerError there.
export const getDocumentErrorNotification = (error: any): AppNotification | null => {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;

  // The backend sent its own structured message (detail.message.title) — let
  // handleServerError/generateErrorObject render it instead of a canned text.
  if (detail?.message?.title) {
    return null;
  }

  if (status === 422) {
    return {
      message: 'Unable to generate document',
      // The backend names the missing field (bank account, sort code, address, company details).
      description: detail?.description || 'Some required details are missing.',
      options: { variant: 'error' },
    };
  }
  if (status === 503) {
    return {
      message: 'Document service is busy',
      description: 'Please try again shortly.',
      options: { variant: 'error' },
    };
  }
  if (status === 404) {
    return {
      message: 'Document not found',
      options: { variant: 'error' },
    };
  }
  return null;
};
